<div class="d-flex flex-column h-100">
  <div class="modal-header">
    <h1 class="modal-title">VPO</h1>
    <span role="button" (click)="dismissModal()" class="ms-auto">
      <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
    </span>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      <!-- PO Number -->
      <div class="mb-3">
        <label for="poNo" class="form-label">PO No</label>
        <input type="text" class="form-control" id="poNo" formControlName="poNo" name="poNo" />
        <small class="text-danger" *ngIf="form.get('poNo')?.touched && form.get('poNo')?.errors?.['required']"
          >PO is required</small
        >
      </div>

      <!-- Alloc Fields -->
      <div class="mb-3">
        <label for="" class="form-label">Alloc:</label>
        <div class="d-flex gap-2">
          <div class="text-center">
            <label class="form-label">O</label>
            <input
              type="text"
              class="form-control"
              (keyup)="onAllocChange($event, 'O')"
              maxlength="1"
              name="allocO"
              #inputO
              [value]="aloc[0] || ''"
            />
          </div>
          <div class="text-center">
            <label class="form-label">P</label>
            <input
              type="text"
              class="form-control"
              (keyup)="onAllocChange($event, 'P')"
              maxlength="1"
              name="allocP"
              #inputP
              [value]="aloc[1] || ''"
            />
          </div>
          <div class="text-center">
            <label class="form-label">L</label>
            <input
              type="text"
              class="form-control"
              (keyup)="onAllocChange($event, 'L')"
              maxlength="1"
              name="allocL"
              #inputL
              [value]="aloc[2] || ''"
            />
          </div>
          <div class="text-center">
            <label class="form-label">M</label>
            <input
              type="text"
              class="form-control"
              (keyup)="onAllocChange($event, 'M')"
              maxlength="1"
              name="allocM"
              #inputM
              [value]="aloc[3] || ''"
            />
          </div>
          <div class="text-center">
            <label class="form-label">N</label>
            <input
              type="text"
              class="form-control"
              (keyup)="onAllocChange($event, 'N')"
              maxlength="1"
              name="allocN"
              #inputN
              [value]="aloc[4] || ''"
            />
          </div>
        </div>
        <small
          class="text-danger"
          *ngIf="form.get('allocation')?.touched && form.get('allocation')?.errors?.['required']"
          >Alloc is required</small
        >
      </div>

      <!-- Required Date -->
      <div class="mb-3">
        <label class="form-label">Required Date</label>
        <p-datepicker
          formControlName="requiredDate"
          [showIcon]="true"
          dateFormat="yy-mm-dd"
          [showOnFocus]="false"
          styleClass="w-100"
          inputStyleClass="w-100"
          placeholder="Select Date"
        >
        </p-datepicker>
        <small
          class="text-danger"
          *ngIf="form.get('requiredDate')?.touched && form.get('requiredDate')?.errors?.['required']"
          >Required Date is required</small
        >
      </div>

      <!-- Supplier -->
      <div class="mb-3">
        <label class="form-label">Supplier <span class="text-danger">*</span></label>
        <ng-select
          class="ng-select-md"
          [items]="traders()"
          bindValue="id"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          placeholder="Select Supplier"
          formControlName="supplierId"
          name="supplierId"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="d-flex flex-column">
              <span>{{ item.firstLabel | titlecase }}</span>
              <small class="text-muted">{{ item.secondLabel }}</small>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="d-flex flex-column">
              <span>{{ item.firstLabel | titlecase }}</span>
              <small class="text-muted">{{ item.secondLabel }}</small>
            </div>
          </ng-template>
        </ng-select>
        <small
          class="text-danger"
          *ngIf="form.get('supplierId')?.touched && form.get('supplierId')?.errors?.['required']"
          >Supplier is required</small
        >
      </div>

      <!-- Craft Code -->
      <div class="mb-3">
        <label class="form-label">Craft Code</label>
        <ng-select
          class="ng-select-md"
          [items]="crafts()"
          bindLabel="label"
          bindValue="id"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          placeholder="Select Craft Code"
          formControlName="craftId"
          name="craftId"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="d-flex flex-column">
              <span>{{ item.craftCode }}</span>
              <span>{{ item.craftDescription }}</span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="d-flex flex-column">
              <span>{{ item.craftCode }}</span>
              <span>{{ item.craftDescription }}</span>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <!-- Craft Types -->
      <div class="mb-3">
        <label class="form-label">Craft Types</label>
        <ng-select
          class="ng-select-md"
          [items]="craftTypes"
          bindLabel="label"
          bindValue="value"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          placeholder="Select Craft Type"
          formControlName="craftType"
          name="craftType"
        >
          <ng-template ng-option-tmp let-item="item">
            <span>{{ item.label }}</span>
          </ng-template>
        </ng-select>
      </div>

      <!-- Variance Reason -->
      <div class="mb-3">
        <label class="form-label">Variance Reason <span class="text-danger">*</span></label>
        <ng-select
          class="ng-select-md"
          [items]="varianceReasons()"
          bindLabel="label"
          bindValue="id"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          placeholder="Select Reason"
          formControlName="varianceReasonId"
          name="varianceReasonId"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="d-flex flex-column">
              <span>{{ item.code }}</span>
              <span>{{ item.description }}</span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="d-flex flex-column">
              <span>{{ item.code }}</span>
              <span>{{ item.description }}</span>
            </div>
          </ng-template>
        </ng-select>
        <small
          class="text-danger"
          *ngIf="form.get('varianceReasonId')?.touched && form.get('varianceReasonId')?.errors?.['required']"
          >Variance Reason is required</small
        >
      </div>

      <!-- Notes -->
      <div class="mb-3">
        <label class="form-label">Back Office Notes <span class="text-danger">*</span></label>
        <textarea
          rows="4"
          class="form-control"
          pInputTextarea
          formControlName="backOfficeNotes"
          name="backOfficeNotes"
        ></textarea>
        <small
          class="text-danger"
          *ngIf="form.get('backOfficeNotes')?.touched && form.get('backOfficeNotes')?.errors?.['required']"
          >Back Office Notes is required</small
        >
      </div>

      <div class="d-flex align-items-center gap-2">
        <div class="mb-3">
          <label class="form-label">Qty <span class="text-danger">*</span></label>
          <input type="number" class="form-control" pInputText formControlName="quantity" name="quantity" />
          <small class="text-danger" *ngIf="form.get('quantity')?.touched && form.get('quantity')?.errors?.['required']"
            >Qty is required</small
          >
        </div>

        <div class="mb-3">
          <label class="form-label">UOFM <span class="text-danger">*</span></label>
          <ng-select
            [items]="uofm()"
            bindLabel="label"
            bindValue="id"
            [searchable]="true"
            [clearable]="true"
            [searchFn]="customSearchFn"
            placeholder="Select UOFM"
            formControlName="uofmId"
            name="uofmId"
          >
            <ng-template ng-label-tmp let-item="item">
              <div class="d-flex flex-column">
                <span>{{ item.code }}</span>
                <span>{{ item.description }}</span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="d-flex flex-column">
                <span>{{ item.code }}</span>
                <span>{{ item.description }}</span>
              </div>
            </ng-template>
          </ng-select>
          <small class="text-danger" *ngIf="form.get('uofmId')?.touched && form.get('uofmId')?.errors?.['required']"
            >UOFM is required</small
          >
        </div>

        <div class="mb-3">
          <label class="form-label">Unit Price <span class="text-danger">*</span></label>
          <input type="number" class="form-control" pInputText formControlName="unitPrice" name="unitPrice" />
          <small
            class="text-danger"
            *ngIf="form.get('unitPrice')?.touched && form.get('unitPrice')?.errors?.['required']"
            >Required</small
          >
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Notes <span class="text-danger">*</span></label>
        <textarea class="form-control" rows="4" formControlName="measureNotes" name="measureNotes"></textarea>
        <small
          class="text-danger"
          *ngIf="form.get('measureNotes')?.touched && form.get('measureNotes')?.errors?.['required']"
          >Notes is required</small
        >
      </div>
    </form>
  </div>
  <div class="modal-footer">
    @if (isUpdate) {
      <button type="submit" class="btn btn-primary" [disabled]="!form.valid" (click)="updateVpo()">Update</button>
    } @else {
      <button type="submit" class="btn btn-primary" [disabled]="!form.valid" (click)="createVpo()">Submit</button>
    }
  </div>
</div>
